import type { FormComponent, SavedComponent } from '../types/form-builder';

const STORAGE_KEY = 'form_builder_saved_components';

export async function saveComponent(component: FormComponent, name?: string): Promise<SavedComponent> {
  const saved: SavedComponent = {
    id: `saved_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    name: name || `Saved ${component.type}`,
    type: component.type,
    data: JSON.parse(JSON.stringify(component)),
    createdAt: new Date().toISOString(),
  };

  const existing = await getSavedComponents();
  existing.push(saved);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));

  return saved;
}

export async function getSavedComponents(): Promise<SavedComponent[]> {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export async function getSavedComponentsByType(type: FormComponent['type']): Promise<SavedComponent[]> {
  const all = await getSavedComponents();
  return all.filter(c => c.type === type);
}

export async function deleteSavedComponent(id: string): Promise<void> {
  const existing = await getSavedComponents();
  const filtered = existing.filter(c => c.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
}

export async function clearSavedComponents(): Promise<void> {
  localStorage.removeItem(STORAGE_KEY);
}
